module.exports = __webpack_public_path__ + "static/media/reflow-sticky2.ada59683.png";